document.addEventListener('DOMContentLoaded', async () => {
    const customerLoginForm = document.querySelector('#customer_login')

    customerLoginForm?.addEventListener('submit', (e) => {
        const email = document.querySelector('#CustomerEmail').value
        const password = document.querySelector('#CustomerPassword').value

        storeCustomerCredentials(email, password)
    })

    const getCustomerAccessToken = async (email, password) => {
        try {
            const customerAccessTokenResponse = await fetch(`${API_URL}/${API_PATH_LIST.CUSTOMER_ACCESS_TOKE_CREATE}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    password
                }),
            })

            const customerAccessTokenData = await customerAccessTokenResponse.json()
            const customerAccessToken = customerAccessTokenData?.data ?? null

            if (!customerAccessToken) {
                throw customerAccessTokenData?.data?.customerErrors ?? 'Failed to get customer access token'
            }

            localStorage.removeItem('email')
            localStorage.removeItem('password')

            return customerAccessToken

        } catch (error) {
            console.error(error)
        }
    }
    const storeCustomerAccessToken = async (customerAccessToken) => {
        storeToLocalStorage(CUSTOMER_ACCESS_TOKEN_KEY, customerAccessToken)
    }

    const storeCustomerCredentials = (email, password) => {
        storeToLocalStorage(CUSTOMER_EMAIL_KEY, email)
        storeToLocalStorage(CUSTOMER_PASSWORD_KEY, password)
    }

    const storeToLocalStorage = (key, data) => {
        try {
            localStorage.setItem(key, data)
        } catch (error) {
            console.error(error)
        }
    }

    const getFromLocalStorage = (key) => {
        try {
            return localStorage.getItem(key)
        } catch (error) {
            console.error(error)
        }
    }

    const prepareCustomerAccessToken = async () => {
        const email = getFromLocalStorage(CUSTOMER_EMAIL_KEY)
        const password = getFromLocalStorage(CUSTOMER_PASSWORD_KEY)
        const customerToken = await getCustomerAccessToken(email, password)

        return storeCustomerAccessToken(customerToken)
    }

    const removeLoader = () => {
        const icoSelectorElement = document.querySelector('.ico-container.disabled.loading')
        icoSelectorElement?.classList?.remove('loading')

        if (document.querySelectorAll('.ico-list-item').length > 0) {
            icoSelectorElement?.classList?.remove('disabled')
        }

        const icoShippingSelectorElement = document.querySelector('.ico-shipping-container.disabled.loading')
        icoShippingSelectorElement?.classList?.remove('loading')

        if (document.querySelectorAll('.ico-shipping-list-item').length > 0) {
            icoShippingSelectorElement?.classList?.remove('disabled')
        }
    }


    let customerAccessToken = localStorage.getItem(CUSTOMER_ACCESS_TOKEN_KEY) ?? ''
    if ((!customerAccessToken || customerAccessToken === 'undefined') && window?.ShopifyAnalytics?.meta?.page?.customerId) {
        customerAccessToken = await prepareCustomerAccessToken()
        removeLoader()
    }

    if (customerAccessToken) {
        removeLoader()
    }

    const updateAddressInShopify = async(address, note) => {
        try {
            const response = await fetch(`${API_URL}/${API_PATH_LIST.CHANGE_CUSTOMER_DEFAULT_ADDRESS}`, {
                method: 'POST',
                body: JSON.stringify({
                    customerAccessToken: getFromLocalStorage(CUSTOMER_ACCESS_TOKEN_KEY),
                    newAddress: {
                        ...address
                    },
                    note
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            if (
                response?.status !== 200 &&
                getFromLocalStorage(CUSTOMER_ACCESS_TOKEN_KEY)
            ) {
                localStorage.removeItem(CUSTOMER_ACCESS_TOKEN_KEY)
                window.location.href = '/account/logout'
                return null
            }

            return JSON.stringify(response)
        } catch (error) {
            console.error(error)
        }
    }

    const IcoElements = document.querySelectorAll('.ico-list-item')
    const icoSelectorElement = document.querySelector('.ico-selector')

    IcoElements.forEach((icoElement) => {
        icoElement.addEventListener('click', async() => {
            icoSelectorElement.classList.remove('error')

            const address = {
                firstName: icoElement.getAttribute('data-first-name'),
                lastName: icoElement.getAttribute('data-last-name'),
                phone: icoElement.getAttribute('data-phone'),
                zip: icoElement.getAttribute('data-zip'),
                address1: icoElement.getAttribute('data-address-1'),
                address2: icoElement.getAttribute('data-address-2'),
                city: icoElement.getAttribute('data-city'),
                country: icoElement.getAttribute('data-country'),
                company: icoElement.getAttribute('data-company'),
                province: icoElement.getAttribute('data-province'),
            }
            const note = icoElement.getAttribute('data-invoice-emails')

            const addressUpdateData = await updateAddressInShopify(address, note)
            if (addressUpdateData?.updateAddress?.customerAddressUpdate?.customerUserErrors?.length > 0) {
                const error = addressUpdateData?.updateAddress?.customerAddressUpdate?.customerUserErrors[0]?.message

                storeToLocalStorage(icoLocalStorageKey, JSON.stringify({
                    companyName: error
                }))

                const companyNameElement = icoSelectorElement.querySelector('.company-name')
                icoSelectorElement.classList.add('error')
                companyNameElement.textContent = error
                return
            }
            const activeIcoData = JSON.parse(getFromLocalStorage(icoLocalStorageKey))
            storeToLocalStorage(icoLocalStorageKey, JSON.stringify({
                ...activeIcoData,
                address : {
                    ...address,
                },
                note
            }))

            window.location.reload()
        })
    })

    Array.from(document.querySelectorAll('.ico-shipping-list-item')).forEach((icoElement) => {
        icoElement.addEventListener('click', (e) => {
            e.preventDefault();

            window.location.reload()
        })
    })

    const activeIco = JSON.parse(getFromLocalStorage(icoLocalStorageKey))
    if (activeIco) {
        await updateAddressInShopify(activeIco.address, activeIco.note)
    }

    document.querySelectorAll('.back-button').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault()
            history.back()
        })
    })
})
